export enum AUTH_SCREEN {
  LOGIN = 'LoginScreen'
}

export enum AUTH_REQUEST_ID_LIST {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  GET_SESSION = 'GET_SESSION',
  POST_VALIDATION_EMAIL = 'POST_VALIDATION_EMAIL',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_COMFIRM = 'FORGOT_PASSWORD_COMFIRM',
  CONFIRM_NEW_PASSWORD = 'CONFIRM_NEW_PASSWORD',
  IS_FIRST_LOGIN = 'isFirstLogin'
}

export enum COGNITO_RESPONSE {
  LIMIT_EXCEEDED_EXCEPTION = 'LimitExceededException',
  CODE_MISMATCH_EXCEPTION = 'CodeMismatchException',
  EXPIRED_CODE_EXCEPTION = 'ExpiredCodeException',
  NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException',
  INVALID_PARAMETER_EXCEPTION = 'InvalidParameterException',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  USER_LAMBDA_VALIDATION_EXCEPTION = 'UserLambdaValidationException'
}

export enum COGNITO_CHALLENGE {
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
}

export enum AUTH_USER_ROLE {
  OWNER = 'OWNER',
  BRANCH_MANAGER = 'BRANCH_MANAGER'
}

export const AUTH_LOCAL_STORAGE_KEY = {
  CLIENT_ID: 'RBH_ClientId',
  EXPIRE_TIME: 'RBH_ExpireTime',
  IS_REMEMBER: 'RBH_IsRemember',
  TOKEN_ID: 'RBH_TokenId',
  ID_TOKEN: 'RBH_IdToken',
  REFRESH_TOKEN: 'RBH_RefreshToken',
  EMAIL: 'RBH_Email',
  MERCHANT_TYPE_ID: 'RBH_MerchantTypeId',
  BUSINESS_TYPE_ID: 'RBH_BusinessTypeId',
};

export const COGNITO_LOCAL_STORAGE_KEY = {
  COGNITO_USER: 'RBH_CognitoUser',
  MERCHANT_USER_ID: 'RBH_MerchantUserId',
};

export const ACCESS_TOKEN_HEADER = 'access-token';
